var e = (i, m, t) => new Promise((c, n) => {
  var s = (o) => {
    try {
      r(t.next(o));
    } catch (a) {
      n(a);
    }
  }, d = (o) => {
    try {
      r(t.throw(o));
    } catch (a) {
      n(a);
    }
  }, r = (o) => o.done ? c(o.value) : Promise.resolve(o.value).then(s, d);
  r((t = t.apply(i, m)).next());
});
import { selfAxios as p } from "@oppein/op-utils";
function f(i) {
  return e(this, null, function* () {
    const {
      data: m
    } = yield p.post(
      "/commoditycenter/commodity/pageCommodityFromOriginalES",
      i
    );
    return m;
  });
}
export {
  f as postPageCommodityFromOriginalES
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/commoditycenter/commodity/pageCommodityFromOriginalES/post.js
// module id = 482
// module chunks = 41